import React from 'react';
import styled from 'styled-components';
import Button from '../buttons/button';

const AboutContainer = styled.div`
  background-color: #f9f9f9;
  text-align: center;
  box-sizing: border-box;
`;

const Heading = styled.h1`
  font-family: 'Helvetica Neue', Helvetica, sans-serif;
  font-weight: bold;
  margin-bottom: 20px;
  font-size: 2.5em;
  color: #333;
`;

const SubHeading = styled.h2`
  font-family: 'Helvetica Neue', Helvetica, sans-serif;
  font-weight: bold;
  margin-bottom: 15px;
  font-size: 1.8em;
  color: #444;
`;

const Paragraph = styled.p`
  font-family: 'Helvetica Neue', Helvetica, sans-serif;
  font-size: 1.1em;
  line-height: 1.6;
  color: #555;
  max-width: 900px;
  margin: 0 auto 20px;
  text-align: start;
`;

const Section = styled.div`
  margin-bottom: 30px;
`;

const GridContainer = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr;
  margin: 40px auto;
  max-width: 1200px;
  padding: 20px;
  box-sizing: border-box;

  @media (min-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
`;

const GridItem = styled.div`
  padding: 20px;
  background: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin: 30px;
  box-sizing: border-box;
`;

const FullWidthGridItem = styled(GridItem)`
  grid-column: span 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (min-width: 768px) {
    grid-column: span 2;
  }
`;

const HighlightedText = styled.span`
  font-weight: bold;
  color: #333;
  font-size: 1.3em;

`;

const AboutMe = () => {
  return (
    <AboutContainer>
      <Heading>About Michelle Hunt</Heading>
      <Section>
        <Paragraph>
          <HighlightedText>Michelle Hunt</HighlightedText> is a renowned food stylist and photographer with over 8 years of experience. Her passion for food and dedication to her craft have made her a trusted name among global culinary businesses. Michelle specializes in creating stunning visuals for products, recipes, and campaigns.
        </Paragraph>
      </Section>
      <GridContainer>
        <GridItem>
          <SubHeading>Services</SubHeading>
          <Paragraph>
            <HighlightedText>Food & Product Photography:</HighlightedText> High-quality imagery tailored to showcase culinary items at their best, emphasizing style and composition.
          </Paragraph>
          <Paragraph>
            <HighlightedText>Stop Motion & Video Production:</HighlightedText> Engaging content perfect for social media and advertisements, driving traffic and boosting brand visibility.
          </Paragraph>
          <Paragraph>
            <HighlightedText>Recipe Creation:</HighlightedText> Nutritious, visually appealing recipes designed to cater to diverse dietary needs and marketing campaigns.
          </Paragraph>
        </GridItem>

        <GridItem>
          <SubHeading>Achievements</SubHeading>
          <Paragraph>
            <HighlightedText>Global Clientele:</HighlightedText> Worked with industry leaders like Lidl, Lindt, and Strong Roots to enhance their market presence through captivating visuals.
          </Paragraph>
          <Paragraph>
            <HighlightedText>Industry Influence:</HighlightedText> Conducts workshops and shares insights to inspire peers and aspiring professionals in food styling and photography.
          </Paragraph>
        </GridItem>

        <FullWidthGridItem>
          <SubHeading>Contact Michelle</SubHeading>
          <Paragraph>
            Partner with Michelle Hunt to elevate your culinary brand. From photography to recipe creation, Michelle offers customized solutions to meet your unique needs.
          </Paragraph>
          <Button text="Contact Me" color="white" url="/contact" />
        </FullWidthGridItem>
      </GridContainer>
    </AboutContainer>
  );
};

export default AboutMe;
